import {html, LitElement} from "lit";
import {customElement} from "lit/decorators.js";
import styles from "./ToggleButtonEBSCO.styles.js";
import {renderPowerNotesLogo} from "../../common/powerNotesLogo.js";

@customElement("pn-toggle-button-ebsco")
export class ToggleButtonEBSCO extends LitElement {
	static styles = [styles];

	render() {
		return html`
			<button aria-label="Toggle PowerNotes sidebar">
				${renderPowerNotesLogo()}
				<span>PowerNotes</span>
			</button>
		`;
	}
}

declare global {
	interface HTMLElementTagNameMap {
		"pn-toggle-button-ebsco": ToggleButtonEBSCO;
	}
}
